import type { FaireProductEntity } from "../../entity_types/product";

export const p_3a3586aq3u: FaireProductEntity = {
  token: "p_3a3586aq3u",
  type: "product",
  name: "2 Tone Big Silver Ball Chain Necklace",
  brandToken: "b_af7f858f",
  brandName: "Ofina Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/358b0af7e5dc1ab5d5cf387e729c669694c55111918abf75765c58322fbf3dfc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/881a5ff41d2348767d10df875cd93b6e5dd6c99b99a34d3235b5d2eae2ce2c99.jpeg",
  ],
  priceDollars: 37,
  description:
    'Updated and bolder than our other signature 2-Tone Ball Chain Necklace (BC-2TG). \nThe silver balls give the gold chain an accented soft, elegant contrast. This necklace layers beautifully or stands out on its own—perfect for everyday wear or special occasions. \n\n* Lengths: 16", 18", 20". Need a custom size, message me ;)\n* Chain: 14k Gold Filled\n* Fixed balls: Sterling Silver\n* Hypoallergenic\n* Can be worn in water',
  tags: [],
  msrpDollars: 74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:17.671Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
